import Immutable from "immutable";
import Filters from "components/filters";
import PropTypes from "prop-types";
import React, { cloneElement } from "react";
import Globalize from "globalize";
import Page from "components/page";

export default function (resource, options = {}) {
    return function (Component) {
        class FilterComponent extends Component {
            constructor(props) {
                super(props);
                this.state = this.state || {};
                if (props.filters) {
                    this.state.filters = props.filters;
                } else {
                    const filters = Object.assign({}, props.location.query);
                    delete filters.__search;
                    delete filters.__bulk_search;
                    delete filters.__bulk_search_type;
                    delete filters.__sort;
                    delete filters.__sort_order;
                    if (options.ignore) {
                        options.ignore.forEach((field) => {
                            delete filters[field];
                        });
                    }

                    this.state.filterClearAll = options.clearAll === false ? false : true;
                    delete filters.campaignId;
                    delete filters.utm_medium;
                    delete filters.utm_campaign;
                    delete filters.utm_source;

                    this.state.filters = Immutable.fromJS(filters);
                }

                if (!this.state.filterTitle) {
                    this.state.filterTitle = Globalize.formatMessage("Refine");
                }

                this.handleFilterChange = this.handleFilterChange.bind(this);
            }

            getChildContext() {
                const childContext = super.getChildContext ? super.getChildContext() : {};
                childContext.filters = this.state.filters;
                return childContext;
            }

            shouldComponentUpdate(nextProps, nextState, nextContext) {
                if (nextState.filters !== this.state.filters || nextState.filterTitle !== this.state.filterTitle) {
                    return true;
                }

                if ("disabledFilters" in this.state) {
                    return nextState.disabledFilters !== this.state.disabledFilters;
                }

                if (super.shouldComponentUpdate) {
                    return super.shouldComponentUpdate(nextProps, nextState, nextContext);
                } else {
                    return true;
                }
            }

            handleFilterChange(filters) {
                this.setState({ filters });
                if (super.handleFilterChange) {
                    super.handleFilterChange(filters);
                }
            }

            render() {
                const content = super.render();

                const { me } = this.context;

                if (content.type !== Page) {
                    return content;
                }

                if (resource === "linesheets" && !me.hasPermission("edit_linesheet")) {
                    return content;
                }

                const sidebarSections = content.props.sidebarSections || [];
                const { brand } = this.props.scope;
                const isOrderIntentTabActive =
                    resource === "order" &&
                    ((this.props.flags.assortmentsOrderIntentNu57496 && brand.hasModuleEnabled("assortments")) ||
                        brand.hasModuleEnabled("assortment_order_intents")) &&
                    !me.isBuyer() &&
                    this.state.tabIndexSelected === 1;

                sidebarSections.push(
                    <Filters
                        key={isOrderIntentTabActive ? "order-intents" : "filters"}
                        resource={isOrderIntentTabActive ? "order-intents" : resource}
                        filtersDisabled={this.state.filtersDisabled}
                        clearAll={this.state.filterClearAll}
                        activeFiltersValues={this.state.filters}
                        onFilterChange={this.handleFilterChange}
                        title={this.state.filterTitle}
                    />,
                );

                return cloneElement(content, { sidebarSections });
            }
        }

        FilterComponent.contextTypes = {
            me: PropTypes.object.isRequired,
            ...FilterComponent.contextTypes,
        };

        FilterComponent.childContextTypes = {
            filters: PropTypes.instanceOf(Immutable.Map).isRequired,
            ...FilterComponent.childContextTypes,
        };

        FilterComponent._pageComponents = FilterComponent._pageComponents || [];
        FilterComponent._pageComponents.push("filters");

        FilterComponent.displayName = Component.displayName || Component.name || "Component";

        return FilterComponent;
    };
}
